import React, { useEffect, useState } from 'react';

import { Modal, Button, Form, FormItemProps, Input, notification, Select } from 'antd';

import { ErrorRender, FormErrorParser } from '@partsbadger/library';
import { PlusOutlined } from '@ant-design/icons';

import { observer } from 'mobx-react';

import QuoteStore from '../../../stores/QuoteStore';

import PartStore from 'stores/PartStore';

import PortalLoading from 'components/PortalLoading';

import CreateNewGroup from '../CreateNewGroup';

import { IPartGroup } from 'types/types';

interface IProps {
    showAddToGroup: boolean;
    onClose: () => void;
}

const AddToGroup: React.FC<IProps> = ({ showAddToGroup, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [showCreateGroup, setShowCreateGroup] = useState(false);

    const [form] = Form.useForm();

    const getGroupList = async () => {
        const params = {};
        await PartStore.getPartsGroupList(params).catch((err: any) => {
            notification.error({
                message: <ErrorRender error={err} />,
                placement: 'topRight',
            });
        });
    };

    useEffect(() => {
        getGroupList();
    }, []);

    const formItemLayout: FormItemProps = {
        labelCol: { span: 24 },
        wrapperCol: { span: 22 },
        labelAlign: 'left',
    };

    const handleSubmit = () => {
        setLoading(true);
        form.validateFields()
            .then(async values => {
                const groupId = values.group;

                const getGroup = PartStore?.partsGroupList.find(item => {
                    return item.id === groupId;
                });

                const getLineItemsIds = getGroup?.line_items
                    .filter(item => {
                        return item.id !== PartStore.selectedlineItemsToGroup;
                    })
                    .map(item => {
                        return item.id;
                    });

                if (getLineItemsIds) {
                    const payload = {
                        name: getGroup?.name,
                        line_items: [...getLineItemsIds, PartStore.selectedlineItemsToGroup],
                    };

                    await PartStore.updatePartsGroup(groupId, payload)
                        .then(() => {
                            notification.success({
                                message: 'The Part has been added successfully',
                                description:
                                    'The part has been added to the group successfully. You can find it in the group details.',
                                placement: 'topRight',
                            });

                            onClose();
                        })
                        .catch((err: any) => {
                            notification.error({
                                message: <ErrorRender error={err} />,
                                placement: 'topRight',
                            });
                        });
                }

                setLoading(false);
            })
            .catch(errorInfo => {
                setLoading(false);

                notification.error({
                    key: 'form-errors',
                    duration: 8,
                    message: 'Please input all required fields',
                    description: <FormErrorParser isAntd4 errors={errorInfo.errorFields} />,
                    placement: 'top',
                    maxCount: 1,
                });
            });
    };

    const selectOptions = PartStore?.partsGroupList?.map(item => {
        return {
            value: item.id,
            label: item.name,
        };
    });

    return (
        <div>
            <Modal
                open={showAddToGroup}
                title="Add To Group"
                width={600}
                destroyOnClose={true}
                onCancel={() => onClose()}
                // bodyStyle={{ overflowY: 'scroll', overflowX: 'auto', height: '60vh' }}
                footer={[
                    <>
                        <div key={1} className="flex justify-between">
                            <Button
                                onClick={() => {
                                    onClose();
                                }}
                                size="large"
                                loading={loading}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                loading={loading}
                                onClick={() => {
                                    handleSubmit();
                                }}
                            >
                                Submit
                            </Button>
                        </div>
                    </>,
                ]}
            >
                <Form form={form}>
                    <div className="flex flex-col">
                        <p>
                            Use this form to add your Parts to an existing Group or to create and edit a new one. Use
                            Groups to organize your parts as needed.
                        </p>

                        <div>
                            <Form.Item
                                label="Add to Existing Group"
                                {...formItemLayout}
                                name="group"
                                rules={[{ required: true, message: 'Please, select one group' }]}
                                className="w-full"
                            >
                                <Select placeholder="Select one group" options={selectOptions} />
                            </Form.Item>
                        </div>

                        <div>
                            <Button
                                icon={<PlusOutlined />}
                                type="primary"
                                onClick={() => {
                                    setShowCreateGroup(true);
                                }}
                            >
                                Create New Group
                            </Button>
                        </div>
                    </div>
                </Form>
            </Modal>

            <CreateNewGroup
                showCreateGroup={showCreateGroup}
                onClose={() => {
                    setShowCreateGroup(false);
                }}
            />
        </div>
    );
};

export default observer(AddToGroup);
